import React from 'react'

import EntityHeader from '../../ui/entity/EntityHeader'
import EntityHeaderTitle from '../../ui/entity/EntityHeaderTitle'
import PromotionForm from '../forms/PromotionForm'

import { IServiceObject } from '../../../types'

interface ICreatePromotionProps {
  orgId: string
  services: IServiceObject[]
  fetchServices: (orgId: string) => void
  createPromotion: (promotion: any) => void
}

export default class CreatePromotion extends React.Component<ICreatePromotionProps> {
  public componentDidMount() {
    this.props.fetchServices(this.props.orgId);
  }

  public render() {
    return (
      <div className='col-12'>
        <EntityHeader>
          <EntityHeaderTitle>Create Promotion</EntityHeaderTitle>
        </EntityHeader>
        <PromotionForm 
          onSubmit={this.createPromotion} 
          services={this.props.services} 
          orgId={this.props.orgId}
        />
      </div>
    )
  }

  public createPromotion = async (promotion: any) => {
    await this.props.createPromotion(promotion)
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/create/CreatePromotion.tsx